module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5HBAW"))).then(() => parcelRequire('d0iPb'));